<template>
  <div class="pricemap-infowindow">
    <PriceMapInfoWindowSkeleton v-if="isLoading" />

    <template v-else>
      <div class="pricemap-infowindow__logo-container">
        <img :class="marker.brand" class="pricemap-infowindow__logo" :src="`${iconsUrl}/${marker.brand}.svg`" :alt="marker.brand">
      </div>
      <img
        v-if="marker.image"
        class="pricemap-infowindow__image"
        :src="marker.image.url"
        :alt="marker.image.alt ? marker.image.alt : marker.name"
      >
      <img
        v-else
        class="pricemap-infowindow__image"
        src="https://statics-dev.radissonhotels.com/main/img/banner-paris.jpg"
        :alt="marker.name"
      >
      <div>
        <h3 class="h3 pricemap-infowindow__title">{{marker.name}}</h3>
        <div class="pricemap-infowindow__description">
          <div>
            <div class="pricemap-infowindow__direction">
              <span>{{ getFullAddress }}</span>
            </div>
            <a
              v-if="!ishotelSoldOut && marker.overviewPath"
              target="_blank"
              class="btn btn-link see-hotel-btn"
              :href="marker.overviewPath">
              <span>{{translate('offSeeHotelPage')}}</span>
            </a>
            <div class="pricemap-infowindow__price">
              <p class="price">{{ ishotelSoldOut ? '' : price.priceFrom.formattedAmount }}</p>
              <p v-if="!ishotelSoldOut" class="text-lower legal" >
                {{translate('offMapLowestRate')}}
              </p>
            </div>
          </div>
          <div v-if="tripAdvisorRating.image || tripAdvisorRating.reviewCount" class="tripadvisor-container d-flex flex-column align-items-end">
            <img
              v-if="tripAdvisorRating.image"
              class="pricemap-infowindow__tripadvisor-image"
              :src="tripAdvisorRating.image"
              alt="Tripadvisor rating">
            <span v-if="tripAdvisorRating.reviewCount" class="pricemap-infowindow__tripadvisor-reviews">
              {{translate('offMapReviews', tripAdvisorRating.reviewCount, tripAdvisorRating.reviewCount)}}
            </span>
          </div>
        </div>
        <div v-if="ishotelSoldOut" class="pricemap-infowindow__no-available">
            {{translate('offNoAvailability')}}
        </div>
        <button
          v-if="!ishotelSoldOut"
          class="btn btn-primary pricemap-infowindow__btn pricemap-infowindow__btn--primary text-white">
          <span>{{translate('offMapBookNow')}}</span>
        </button>
        <a
          v-if="ishotelSoldOut && marker.overviewPath"
          target="_blank"
          class="btn btn-primary pricemap-infowindow__btn pricemap-infowindow__btn--primary text-white"
          :href="marker.overviewPath">
          <span>{{translate('offSeeHotelPage')}}</span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'PriceMapInfoWindow',
  props: {
    marker: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    tripAdvisorRating: Object,
    price: Object
  },
  components: {
    PriceMapInfoWindowSkeleton: () => import('@/components/multi-offers/PriceMapInfoWindowSkeleton')
  },
  data: () => ({
    iconsUrl: `${assetsUrl}/img/logos/inverse`
  }),
  computed: {
    getFullAddress () {
      const { city, country } = this.marker

      return `${city || ''}${city && country && ', '}${country || ''}`
    },
    ishotelSoldOut () {
      return !this.price?.priceFrom?.amount
    }
  }
}
</script>

<style lang="scss">
  .gm-style .gm-style-iw-c {
    padding: 1.6rem 2.4rem !important;
    width: 32.5rem !important;
    border-radius: 1rem;
    box-shadow: none;
    border: 0.1rem solid color("alto");
  }

  .gm-style .gm-style-iw-t::after {
    content: "";
    border-style: solid;
    border-width: 4.7rem 1.5rem 0 1.5rem;
    border-color: color("white") transparent transparent transparent;
    height: 0;
    width: 0;
    transform: translate(-50%, -1.5rem);
    box-shadow: none;
    background: none !important;
  }

  .gm-style-iw-d {
    font-family: NotoSans, NotoSans-fallback, sans-serif;
  }

  .gm-ui-hover-effect {
    display: none !important;
  }

  .pricemap-infowindow {
    font-weight: 400;
    /* min-width: 32rem; */

    &__logo-container {
      position: absolute;
      top: 2.4rem;
      right: 3.2rem;
      height: 2.5rem;
      max-width: 10rem;
    }

    &__logo {
      position: relative;
      width: 100%;
      height: 100%;

      &.pis {
        height: 150%;
      }
    }

    &__image {
      width: 100%;
      height: 12.2rem;
      object-fit: cover;
    }

    &__title {
      font-size: 1.6rem;
    }

    &__description {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      max-width: 100%;
      margin-bottom: 1rem;

      .tripadvisor-container {
        margin-left: 2rem;
        flex-shrink: 0;
      }

      .see-hotel-btn {
        font-size: 1.2rem
      }
    }

    &__no-available {
        font-weight: 700;
        font-size: 1.4rem;
        line-height: 1.3rem;
        margin-bottom: 1.5rem;
      }

    &__direction {
      color: color("dark-grey");
      font-size: 1.2rem;
      margin: 0.8rem 0 0.6rem 0;
    }

    &__price {
      .price {
        margin-bottom: 0;
        margin-top: 1rem;
        font-size: 1.4rem;
        font-weight: 700;
      }

      .legal {
        font-size: 1rem;
        color: #53565a;
        line-height: 1rem;
        margin-bottom: 0;
      }
    }

    &__tripadvisor-image {
      margin-top: 0.8rem;
      height: 1.2rem;
    }

    &__tripadvisor-reviews {
      font-size: 1.2rem;
      color: #323232;
    }

    .btn.btn-primary {
      &.pricemap-infowindow__btn {
        padding: 1.4rem;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 1.2rem;
        border-radius: 4.8rem;
        width: 100%;
      }
    }
  }
</style>
